module.exports = __webpack_public_path__ + "img/biggerBuddies.5c98b7f8.png";